import { configureStore } from "@reduxjs/toolkit";
import { rootReducer as reducer } from "hcc-binder";

export const store = configureStore({
  reducer,
});
